import { toast } from 'react-toastify';
import API from '@aws-amplify/api';
import { t } from 'i18next';

const usePrintInvoice = () => {
    //#region Print
    const printInvoice = async (state, patch, downloadRef) => {
        const id = toast.loading(t('Finances.Invoices.PrintingInvoice'));

        try {
            let res = await API.post('ShipyardAPI', `/finances/invoices/${state.AppInstID}/print`, {
                body: {
                    InvoiceID: state?.InvoiceID,
                    AppTermSchoolPeriodID: state?.AppTermSchoolPeriodID,
                },
            });

            let newState = Object.assign({}, state, { DownloadURL: res?.pdfResponse?.pdfURL });

            patch(newState);

            downloadRef.current?.click?.();

            toast.success(t('Finances.Invoices.InvoicePrinted'));
        } catch (e) {
            toast.error(t('General.AjaxError'));
        } finally {
            toast.dismiss(id);

            let newState = Object.assign({}, state, { DownloadURL: null });

            patch(newState);
        }
    };
    //#endregion Print

    return { printInvoice };
};

export default usePrintInvoice;
